/**
 * @param {Object} props
 * @param {IconSize} [props.iconSize]
 * @returns {React.ReactElement} The rendered component
 */
const Send = ({ iconSize }) => {
  if (iconSize === 'md') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.8291 2.69348L20.0498 2.73547L20.2637 2.80676C20.4024 2.86349 20.5333 2.9384 20.6523 3.02942L20.8213 3.17786L20.9697 3.34778C21.1061 3.52618 21.2065 3.73065 21.2637 3.94934C21.3398 4.24109 21.3366 4.54875 21.2549 4.83899C21.2532 4.84496 21.2518 4.85159 21.25 4.85754L16.1729 21.6007L16.1709 21.5997C16.0753 21.9249 15.8856 22.2148 15.624 22.4308C15.3575 22.6506 15.0298 22.7847 14.6855 22.8136C14.3412 22.8424 13.9958 22.7654 13.6963 22.5929C13.3969 22.4204 13.1576 22.1601 13.0098 21.8478V21.8468L9.45605 14.5441L2.1416 10.9855L2.14258 10.9845C1.8342 10.8363 1.57709 10.5995 1.40625 10.3029C1.23388 10.0034 1.15672 9.6579 1.18555 9.3136L1.20117 9.18567C1.24908 8.88884 1.37509 8.60828 1.56738 8.37512L1.65332 8.27942C1.85735 8.06725 2.11391 7.91083 2.39746 7.82727L19.1416 2.75012C19.1478 2.74825 19.1549 2.74601 19.1611 2.74426C19.3788 2.68305 19.6062 2.66598 19.8291 2.69348ZM3.7041 9.52063L10 12.5841L14.0303 8.55481C14.4208 8.16448 15.0538 8.16449 15.4443 8.55481C15.8347 8.9453 15.8347 9.57838 15.4443 9.96887L11.4141 13.9982L14.4775 20.296L19.167 4.83215L3.7041 9.52063Z"
          fill="#002967"
        />
      </svg>
    );
  }
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3886_6800)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8162 0.00980001L14.992 0.0430031L15.1619 0.0996438C15.3273 0.167222 15.4781 0.267414 15.6053 0.394566C15.7324 0.521707 15.8326 0.672586 15.9002 0.837925L15.9568 1.00785L15.99 1.18363C16.0118 1.36071 15.9987 1.54102 15.95 1.7139C15.9486 1.71891 15.9466 1.72454 15.9451 1.72953L11.9119 15.0313L11.9109 15.0303C11.835 15.2887 11.6842 15.5189 11.4763 15.6905C11.2645 15.8652 11.0039 15.9713 10.7303 15.9942C10.4568 16.017 10.1829 15.9562 9.9451 15.8194C9.70941 15.6836 9.51987 15.4795 9.40213 15.2344L6.57498 9.42386L0.764436 6.59769L0.765413 6.59671C0.520506 6.47905 0.316212 6.29119 0.180452 6.0557C0.043435 5.81779 -0.0182178 5.54316 0.00467054 5.26957L0.0173658 5.168C0.0553308 4.93188 0.155436 4.70893 0.308381 4.52347L0.376741 4.4473C0.538833 4.27871 0.742277 4.15433 0.967561 4.08792L14.2713 0.0547219L14.2859 0.0498391C14.4588 0.00114648 14.6391 -0.0119662 14.8162 0.00980001ZM2.00369 5.43363L7.0076 7.8682L10.2107 4.66605C10.521 4.35591 11.0245 4.35583 11.3347 4.66605C11.6444 4.9762 11.6444 5.47894 11.3347 5.7891L8.13065 8.99222L10.5652 13.9952L14.2898 1.70902L2.00369 5.43363Z"
          fill="#002967"
        />
      </g>
      <defs>
        <clipPath id="clip0_3886_6800">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Send;
